"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const getCachedData = () => {
    try {
        const cachedHeaderItem = localStorage.getItem('vp-header');
        return cachedHeaderItem ? JSON.parse(cachedHeaderItem) : null;
    }
    catch (_a) {
        return null;
    }
};
const useCache = (isServer, memberId, siteId, path) => {
    const isOutdated = (0, react_1.useMemo)(() => {
        if (isServer)
            return true;
        try {
            const cachedHeaderItem = localStorage.getItem('vp-header');
            const cachedHeaderConfigItem = localStorage.getItem('vp-header-config');
            const localCache = cachedHeaderItem ? JSON.parse(cachedHeaderItem) : null;
            const cacheConfig = cachedHeaderConfigItem ? JSON.parse(cachedHeaderConfigItem) : null;
            if (!localCache || !cacheConfig)
                return true;
            const now = new Date();
            const since = new Date(cacheConfig.date);
            const isOutdated = now.getTime() - since.getTime() > 15 * 1000 * 60;
            const openingHasHappened = [7, 9, 12, 19].some((hour) => since.getHours() < hour && now.getHours() === hour);
            const siteIdChanged = cacheConfig.siteId !== siteId;
            const memberIdChanged = cacheConfig.memberId !== memberId;
            const pathChanged = cacheConfig.path !== path;
            return isOutdated || openingHasHappened || siteIdChanged || memberIdChanged || pathChanged;
        }
        catch (_a) {
            return true;
        }
    }, [siteId, isServer, memberId, path]);
    const data = isOutdated ? null : getCachedData();
    const setCache = (0, react_1.useCallback)((data) => {
        if (isServer || !data || !siteId || !memberId)
            return;
        try {
            localStorage.setItem('vp-header', JSON.stringify(data));
            localStorage.setItem('vp-header-config', JSON.stringify({
                date: new Date(),
                memberId,
                path,
                siteId,
            }));
        }
        catch (_a) {
            localStorage.removeItem('vp-header');
            localStorage.removeItem('vp-header-config');
        }
    }, [isServer, siteId, memberId, path]);
    return [data, setCache];
};
exports.default = useCache;
